import React, { useState, useEffect, useRef } from "react";
import "./index.scss";
import { useNavigate } from "react-router-dom";

const StickyButton = () => {
  const [isSticky, setIsSticky] = useState(false);
  const buttonRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const button = buttonRef.current;
      const buttonTop = button.offsetTop;

      if (window.scrollY > buttonTop) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const navigate = useNavigate();
  return (
    <button
      ref={buttonRef}
      className={`sticky-button ${isSticky ? "fixed" : ""}`}
      onClick={() => {
        navigate("/faire-don");     window.scrollTo(0, 0);
      }}
    >
      Faire un don
    </button>
  );
};

export default StickyButton;
